<div *ngIf="isMobileApplicationType; then deviceConfigTemplateForMobileAndTab ; else deviceConfigTemplate"></div>
<ng-template #deviceConfigTemplate>
  <div>
    <div *ngIf="showAutoResponsiveToggle" class="auto-responsive-container">
      <div class="auto-toggle">
        <label>Auto Responsive</label>
        <wms-toggle [hideLabels]="true" [onValue]="true" [offValue]="false" [model]="autoResponsive" (onChange)="onAutoResponsiveChange($event)"></wms-toggle>
      </div>
    </div>
    <div *ngIf="!showAutoResponsiveToggle || !autoResponsive">
      <table class="wm-table {{tableClass}}" ngClass="{{tableClass}} ">
        <thead>
        <tr>
          <th>{{deviceHeader}}</th>
          <th>{{widthHeader}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td >{{locale.LABEL_PROPERTY_MOBILE}}</td>

          <td><select [(ngModel)]="_model.xs" (change)="_onChange()">
            <option *ngFor="let item of deviceSizes;">{{item}}</option>
          </select></td>
        </tr>
        <tr>
          <td>{{locale.LABEL_TABLET_PORTRAIT}}</td>
          <td><select [(ngModel)]="_model.sm" (change)="_onChange()">
            <option *ngFor="let item of deviceSizes;">{{item}}</option>
          </select></td>
        </tr>
        <tr>
          <td>{{locale.LABEL_LAPTOP_TABLET_LANDSCAPE}}</td>
          <td><select [(ngModel)]="_model.md" (change)="_onChange()">
            <option *ngFor="let item of deviceSizes;">{{item}}</option>
          </select></td>
        </tr>
        <tr>
          <td>{{locale.LABEL_LARGE_SCREEN}}</td>
          <td><select  [(ngModel)]="_model.lg" (change)="_onChange()" >
            <option *ngFor="let item of deviceSizes;">{{item}}</option>
          </select></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<ng-template #deviceConfigTemplateForMobileAndTab >
<!--  device config template for  tab-->
  <div>
    <table class="wm-table wm-table-dark">
      <thead>
      <tr>
        <th>{{locale.LABEL_PROPERTY_MODE}}</th>
        <th>{{widthHeader}}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
         <td>{{locale.LABEL_PROPERTY_MOBILE}}</td>
          <td>
            <select [(ngModel)]="_model.xs" (change)="_onChange()">
              <option *ngFor="let item of deviceSizes;">{{item}}</option>
            </select>
          </td>
      </tr>
      <tr>
        <td>{{locale.LABEL_TABLET_PORTRAIT}}</td>
        <td><select [(ngModel)]="_model.sm" (change)="_onChange()">
          <option *ngFor="let item of deviceSizes;">{{item}}</option>
        </select></td>
      </tr>
      <tr>
        <td>{{locale.LABEL_LAPTOP_TABLET_LANDSCAPE}}</td>
        <td><select [(ngModel)]="_model.md" (change)="_onChange()">
          <option *ngFor="let item of deviceSizes;">{{item}}</option>
        </select></td>
      </tr>
      </tbody>
    </table>
  </div>

</ng-template>
